import React, { FC } from 'react'

//* utils
import { UseCaseTypes } from '../../../../constants/blogUseCase'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../../models/others/menuGroup'
import { generateAdData } from '../../../../utils/functions.utils'

//* components
import Bio from '../../../global/bio'
import BlogListing from '../../../global/blogListing'
import Layout from '../../../layouts/layout'
import BlogNavigation from '../navigation'

type Props = {
  path: string
  pageContext: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const AuthorListings: FC<Props> = ({
  path,
  pageContext,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  if (!pageContext.pageData) return null
  const authorListingData = {
    useCase: pageContext.pageData.useCase || '',
    isSecondaryBlog: pageContext.pageData.isSecondaryBlog || false,
    locale: pageContext.pageData.locale || LocaleCodes.ENGLISH.code,
    featuredResource: pageContext.blogFeaturedResource || null,
    blogNav: pageContext.pageData.blogNav || null,
    path: pageContext.pageData.path || '/blog',
    blogs: pageContext.pageData.blogs || [],
    pageNumber: pageContext.pageData.pageNumber || 0,
    totalPages: pageContext.pageData.totalPages || 0,
    totalListingPages: pageContext.pageData.totalListingPages || 0,
    bio: pageContext.pageData.bio || null,
    slug: pageContext.pageData.slug || '',
    subscribe: pageContext.pageData.subscribe || null,
    seo: pageContext.pageData.bio?.seoMetadata || null,
  }

  const getFeaturedAd = () => {
    if (authorListingData.featuredResource) {
      return generateAdData(authorListingData.featuredResource)
    }
  }

  return (
    <Layout.Template
      lang={authorListingData.locale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}>
      <div data-cy="AuthorListing">
        {authorListingData.blogNav && (
          <BlogNavigation
            blogNav={authorListingData.blogNav}
            pagePath={authorListingData.path}
            isNonNavigationPage={true}
            useCase={authorListingData.useCase}
          />
        )}

        {authorListingData.blogs.length && (
          <>
            {authorListingData.pageNumber === 1 && authorListingData.bio && (
              <Bio
                type="bioHero"
                data={authorListingData.bio}
                useCase={authorListingData.useCase}
                isSecondaryBlog={authorListingData.isSecondaryBlog}
                locale={authorListingData.locale}
              />
            )}

            <BlogListing
              posts={authorListingData.blogs}
              totalPages={authorListingData.totalPages}
              pageNumber={authorListingData.pageNumber}
              slug={authorListingData.slug}
              subscribe={authorListingData.subscribe}
              seoData={authorListingData.bio && authorListingData.seo}
              numListingPages={authorListingData.totalListingPages}
              blogFRData={getFeaturedAd()}
              locale={authorListingData.locale}
              disableListingTitle={authorListingData.useCase !== UseCaseTypes.MAIN_BLOG}
              isMainBlog={authorListingData.useCase === UseCaseTypes.MAIN_BLOG}
            />
          </>
        )}
      </div>
    </Layout.Template>
  )
}

export default AuthorListings
